module.exports = __webpack_public_path__ + "static/media/BG.70e9c43e.png";